module.exports = __webpack_public_path__ + "img/good.a1ff6d2d.png";